<template>
  <ul class="event-list">
    <app-loader class="spinner" v-show="eventsStatus === 'loading' && events && !events.length"/>
    <li
      v-for="event of events"
      :key="event.id"
      @click="onSelectEvent(event.id)"
      :style="{'margin-top': marginTop}"
      :class="{activeEvent: (event.id === currentEventId
       || event.id === currentEventId) && backlight}"
      class="event-list__event-item"
    >
      <event-item
        :currency="event.eventCurrency || currency"
        :event="event"
        :onDeleteEvent="onDeleteEvent"
        :show-unread-messages="showUnreadMessages"
        :event-date-mode="eventDateMode"
      />
    </li>
    <li
      v-if="eventsStatus !== 'loading' && events && !events.length"
      class="event-list__event-item_no-event">
      <img
        class="no-events-image"
        src="../../assets/img/sad.svg"
        alt="sad.svg"
      >
      <div class="no-events-title">
        {{ $t(noEventsPhrase) }}
      </div>
    </li>
  </ul>
</template>

<script>
import EventItem from '../EventItem/EventItem';
import AppLoader from '../AppLoader/AppLoader';

export default {
  name: 'EventList',
  components: {
    AppLoader,
    EventItem,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    currentEvent: {
      type: Object,
    },
    currency: {
      type: String,
      default: '',
    },
    currentEventId: {
      type: Number,
      default: 0,
    },
    routeId: {
      type: String,
      default: '',
    },
    marginTop: {
      type: String,
      default: '20px',
    },
    backlight: {
      type: Boolean,
      default: false,
    },
    onDeleteEvent: {
      type: Function,
      default: () => {},
    },
    onSelectEvent: {
      type: Function,
      default: () => {},
    },
    eventsStatus: {
      type: String,
      default: '',
    },
    showUnreadMessages: {
      type: Boolean,
      default: false,
    },
    noEventsPhrase: {
      type: String,
      default: '',
    },
    eventDateMode: {
      type: String,
      default: 'byUpdate',
      validate: (val) => ['byUpdate', 'byCreate'].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
  .spinner{
    margin: 54px auto;
    font-size: 10px;
  }
  .event-list {
    position: relative;
    list-style-type: none;
    padding: 0;
    margin: 0;
    /*padding: 0 5px;*/
    /*overflow-y: auto;*/
    /*max-height: 60vh;*/
    /*-ms-overflow-style: none;  !* IE and Edge *!*/
    /*scrollbar-width: none;  !* Firefox *!*/
    /*&::-webkit-scrollbar {*/
    /*  display: none; !* Chrome, Safari and Opera *!*/
    /*}*/
  }

  .event-list__event-item {
    box-sizing: border-box;
    background-color: white;
    text-align: left;
    padding: 7px;
    min-height: 90px;
    border-radius: 6px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 76, 165, 0.16);
    position: relative;
  }

  .event-list__event-item.activeEvent {
    outline: none;
    box-shadow: 0 1px 6px rgba(41, 121, 255, 0.61);
  }

  .event-list__event-item_no-event {
    margin-top: 10px;
    padding: 7px;
    min-height: 90px;
  }
  .no-events-image {
    width: 71px;
    height: 52px;
  }
  .no-events-title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #303F9F;
    opacity: 0.2;
  }
</style>
